package com.parmartechnologies.communication.core.repository

import com.parmartechnologies.core.feature.auth.model.FriendlyUser
import com.parmartechnologies.core.feature.auth.model.Language
import com.parmartechnologies.core.feature.locale.Localization
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlin.time.ExperimentalTime

class AuthRepository {

    @OptIn(ExperimentalTime::class)
    val tempAuthLiveData: MutableStateFlow<FriendlyUser> = MutableStateFlow(FriendlyUser())
    val isLoggedInState: MutableStateFlow<Boolean> = MutableStateFlow(false)
    val isLoggedIn: StateFlow<Boolean> get() = isLoggedInState

    val isAuthContainerVisibleState: MutableStateFlow<Boolean> = MutableStateFlow(false)
    val isAuthContainerVisible: StateFlow<Boolean> get() = isAuthContainerVisibleState

    val otpState: MutableStateFlow<String> = MutableStateFlow("")
    @OptIn(ExperimentalTime::class)
    val authLiveData: MutableStateFlow<FriendlyUser> = MutableStateFlow(FriendlyUser())
    val authUser: StateFlow<FriendlyUser>
        get() = authLiveData

    val selectedLanguageState: MutableStateFlow<Language> = MutableStateFlow(Language())
    val selectedLanguage: StateFlow<Language> get() = selectedLanguageState

    val localizationState: MutableStateFlow<Localization> = MutableStateFlow(Localization())
    val localization: StateFlow<Localization> get() = localizationState

    val mobileNumberState: MutableStateFlow<String> = MutableStateFlow("")
    val mobileNumber: StateFlow<String> get() = mobileNumberState

    val profilesState: MutableStateFlow<List<FriendlyUser>> = MutableStateFlow(arrayListOf())
    val profiles: StateFlow<List<FriendlyUser>>
        get() = profilesState

}